export const SET_TRAFFIC = 'user/SET_TRAFFIC'
export const SET_SHOW_CLOSED_SIG_EVENTS = 'user/SET_SHOW_CLOSED_SIG_EVENTS'
export const SET_DEFAULT_BASEMAP = 'user/SET_DEFAULT_BASEMAP'
export const SET_SIG_EVENT_DISPLAY_ORDER = 'user/SET_SIG_EVENT_DISPLAY_ORDER'
export const SET_INCIDENT_DISPLAY_ORDER = 'user/SET_INCIDENT_DISPLAY_ORDER'
export const SET_TIMESTAMP_FORMAT = 'user/SET_TIMESTAMP_FORMAT'
export const FETCH_START = 'user/FETCH_START'
export const FETCH_SUCCESS = 'user/FETCH_SUCCESS'
export const FETCH_FAILURE = 'user/FETCH_FAILURE'
